import template from './input.html' with { type: 'html' };

export default {
	name: 'CInput',
	props: {
		isDisabled: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: null
		},
		value: {
			type: [String, Number]
		}
	},
	methods: {
		emitTrimmedValue(event) {
			const trimmedValue = event.target.value.trim();
			const emojisFreeValue = trimmedValue.replace(/[^\p{L}\p{N}\p{P}\p{Z}\\+^$]/gu, '');
			event.target.value = emojisFreeValue;
			this.$emit(event.type, event.target);
			this.$emit('input', event.target.value);
		}
	},
	template
};
